import { render, staticRenderFns } from "./AppointmentEditSkeleton.vue?vue&type=template&id=66d40e4e&scoped=true"
import script from "./AppointmentEditSkeleton.vue?vue&type=script&lang=ts"
export * from "./AppointmentEditSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d40e4e",
  null
  
)

export default component.exports